import React, { Component } from 'react';
import './App.css';
import './styles/task.css';
import TodoApp from './components/containers/todoApp-container';

class App extends Component {
  render() {
    return (
      <TodoApp />
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js